/* eslint-disable */
// istanbul ignore file
import React, { useCallback, type Dispatch } from 'react'
import { CircularProgress } from '@mui/material'
import LanguageStrings from '../../../i18n/locales'
import { useNavigate } from 'react-router-dom'
import { siteDeleteCampaign } from '../../site-management/redux/actionCreators'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import type { RootState } from '../../../store'
import GenericModal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { APIConfiguration } from '../../../utils/apiConfiguration'
import { Tooltip } from '@mui/material'
import { MemoManagementInfoHeader } from '../../common/ManagementInfoHeader'

const SiteInformationStrings = LanguageStrings().AssetManagementCollectionStrings.SiteInformationComponent
const httpStatus = APIConfiguration

const SiteInformation = (props: PropsFromRedux & { siteInfo: any, imageBinaryData: any }): JSX.Element => {
  const navigate = useNavigate()
  const [selectedSiteId, setSelectedSiteId] = React.useState('')
  const [selectedSiteName, setSelectedSiteName] = React.useState('')
  const [confirmDeletePopup, setConfirmDeletePopup] = React.useState(false)
  const [showDeleteStatus, setShowDeleteStatus] = React.useState(false)
  const siteDeleteStatus = useSelector(
    (state: RootState) => state.siteDeleteState
  )

  const handleEdit = useCallback(()=>{
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    navigate(`/edit-site/${props.siteInfo.siteInfo.id}`)
  },[props])

  const handleDelete = useCallback(()=>{
    setSelectedSiteId(props.siteInfo.siteInfo.id)
    setSelectedSiteName(props.siteInfo.siteInfo.name)
    setConfirmDeletePopup(true)
  },[props])

  const handleDeleteCampaign = (): void => {
    setConfirmDeletePopup(false)
    setShowDeleteStatus(true)
    props.siteDeleteCampaign(selectedSiteId, selectedSiteName)
  }

  const handleDeleteCampaignWithFailure = (): JSX.Element => {
    /* istanbul ignore next */
    if (siteDeleteStatus.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={SiteInformationStrings.successfullyDeleted}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
            navigate('/site-list') // Redirect to /site-list after closing the modal
          }}
          onClose={() => {
            setShowDeleteStatus(false)
            navigate('/site-list') // Redirect to /site-list after closing the modal
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {SiteInformationStrings.FullMsgSiteDeletedSuccessfully}
          </p>
        </GenericModal>
      )
    } else if (siteDeleteStatus.isLoading) {
      return (
        <GenericModal title={'Loading...'}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </GenericModal>
      )
    } else if (siteDeleteStatus.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {siteDeleteStatus.error} </p>
        </GenericModal>
      )
    } else if (siteDeleteStatus.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (siteDeleteStatus.httpStatus === httpStatus.ACCESS_FORBIDDEN_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {siteDeleteStatus.error} </p>
        </GenericModal>
      )
    }
  }
  
  return (
    <>
      <MemoManagementInfoHeader 
        title={SiteInformationStrings.SiteInformation}
        binaryData={props.imageBinaryData?.binaryData} 
        name={props?.siteInfo?.siteInfo?.siteName} 
        description={props?.siteInfo?.siteInfo?.description} 
        createdOn={props?.siteInfo?.siteInfo?.install_date}
        handleEdit={handleEdit}
        handleDelete={handleDelete} />

      {confirmDeletePopup && (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={'Delete Site'}
          LabelPositive="Confirm"
          LabelNegative="Cancel"
          onClickPositive={handleDeleteCampaign}
          onClose={() => { setConfirmDeletePopup(false) }}
          onClickNegative={() => { setConfirmDeletePopup(false) }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {SiteInformationStrings.DeleteConfirmation}<br/><br/>
            {SiteInformationStrings.DeleteConfirmationWarning}
          </p>
        </GenericModal>
      )}
        {
            /* istanbul ignore next */
            showDeleteStatus && handleDeleteCampaignWithFailure()
        }
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  siteDeleteCampaign: (selectedAssetId: string, selectedAssetName: string) => { dispatch(siteDeleteCampaign(selectedAssetId, selectedAssetName)) }
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(SiteInformation)
